import { useSnackbar } from 'notistack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DisplayType } from '../../../../generated/core-api/graphql-react-query';
import DetectionSnackbarActions from './Components/DetectionSnackbarActions';
import DetectionSnackbarContent from './Components/DetectionSnackbarContent';

export const SEARCH_DETECTION_SNACKBAR_KEY = 'search-detection-snackbar';

interface DetectionSnackbarProps {
  cardId: string;
  cardTitle?: string;
  commandTitle?: string;
  tabId?: string;
}

export default function useDetectionSnackbar(
  display: (cardId: string, displayType: DisplayType, tabId?: string | null) => void,
) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { t } = useTranslation('notifications');

  return React.useCallback((props: DetectionSnackbarProps) => {
    const {
      cardId,
      cardTitle,
      commandTitle,
      tabId,
    } = props;

    closeSnackbar(SEARCH_DETECTION_SNACKBAR_KEY);
    enqueueSnackbar(
      DetectionSnackbarContent({
        title: t('new-detection.inline-body', {
          detection: commandTitle,
          title: cardTitle,
        }),
      }),
      {
        key: SEARCH_DETECTION_SNACKBAR_KEY,
        variant: 'info',
        action: DetectionSnackbarActions({
          actionLabel: t('new-detection.open-inline'),
          onAction: () => {
            display(cardId, DisplayType.Detection, tabId);
            closeSnackbar(SEARCH_DETECTION_SNACKBAR_KEY);
          },
        }),
        autoHideDuration: 5000,
        hideIconVariant: true,
        style: {
          width: '100%',
        },
      },
    );
  }, [closeSnackbar, display, enqueueSnackbar, t]);
}
